import React, {ChangeEvent, Dispatch, useState} from 'react';
import {
  Stack,
  TextField,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  SelectChangeEvent,
  OutlinedInput, FormHelperText
} from '@mui/material';

import { InformationPanelFormState } from './InformationPanel';
import stateOptions from '../../lib/US_STATES'
import useSession from "../../hooks/user/useSession";
import TextMaskCustom from "../../components/TextMaskCustom";
interface HerdLocFormProps {
  formState: InformationPanelFormState;
  setFormState: Dispatch<InformationPanelFormState>;
  usePdfLayout?: boolean;
}
export default function HerdLocation({ formState, setFormState, usePdfLayout = false }: HerdLocFormProps) {
  const {userInfo} = useSession();

  const [zipCodeError, setZipCodeError] = useState(false);
  const [zipCodeHelperText, setZipCodeHelperText] = useState('');

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const {target: {name, value}} = event;
    const parseList = ['code'];

    if (name === 'zip_code' && value.length >= 5)
      setZipCodeError(false);

    setFormState({ ...formState, [name]: parseList.includes(name) && value !== '' ? parseInt(value) : value });
  }

  const handleSelectChange = (event: SelectChangeEvent) => {
    const { target: { name, value } } = event;
    setFormState({ ...formState, [name]: value });
  };

  const handleBlur = (event) => {
    const {target: {name, value}} = event;

    if (name === 'zip_code' && value.length < 5) {
      setZipCodeError(true);
      setZipCodeHelperText('Zip code must have at least 5 digits');
    }
  };

  return (
      <Stack direction="column" spacing={2} sx={{ width: '100%', maxWidth: 'sm' }}>
        <Stack direction={usePdfLayout ? 'column' : {xs: 'column', sm: 'row'}} spacing={2}>
          <TextField
            id="herd-streetAddress-input"
            required
            name="street_address"
            label="Street Address"
            value={formState.street_address}
            placeholder='1234 Old Farm Rd.'
            onChange={handleInputChange}
            disabled={userInfo.orgTypeAbbrev === 'RE'}
            sx={{width: usePdfLayout ? '100%' : {xs: '100%', sm: '60%'}}}
          />
          <TextField
            id="herd-city-input"
            required
            name="city"
            label="City"
            value={formState.city}
            placeholder='Pleasant View'
            onChange={handleInputChange}
            disabled={userInfo.orgTypeAbbrev === 'RE'}
            sx={{width: usePdfLayout ? '100%' : {xs: '100%', sm: '40%'}}}
          />
        </Stack>

        <Stack direction="row" spacing={2}>
          <FormControl
            required
            disabled={userInfo.orgTypeAbbrev === 'RE'}
            sx={{ width: 100 }}
          >
            <InputLabel id="herd-state-select-label">State</InputLabel>
            <Select
              labelId="herd-state-select-label"
              id="herd-state-select"
              name="state_code"
              label="State"
              value={formState.state_code}
              onChange={handleSelectChange}
            >
              <MenuItem value="">No Selection</MenuItem>
              {stateOptions?.map((option) => (
                <MenuItem key={option} value={option}>{option}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl
            required
            disabled={userInfo.orgTypeAbbrev === 'RE'}
            sx={{width: 150}}
          >
            <InputLabel>Zip Code</InputLabel>
            <OutlinedInput
              id='herd-zipCode-input'
              name='zip_code'
              label='Zip Code'
              value={formState.zip_code}
              placeholder='85164'
              onChange={handleInputChange}
              inputComponent={TextMaskCustom as any}
              inputProps={{mask: '00000-0000', eager: 'remove'}}
              onBlur={handleBlur}
              error={zipCodeError}
            />
            {zipCodeError &&
              <FormHelperText error>
                {zipCodeHelperText}
              </FormHelperText>}
          </FormControl>
        </Stack>
      </Stack>
  )
}